export default "__VITE_ASSET__efbba966__"